/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Inspections_SummaryInputs */



/**
* | output |
* | --- |
* | "Inspections on behalf of OCIMF members, carried out by OCIMF-accredited Master Mariners and Chief Engineers across tankers, barges, bulk carriers and offshor..." |
*
* @param {Service_Inspections_SummaryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_inspections_summary = /** @type {((inputs?: Service_Inspections_SummaryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Inspections_SummaryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("代表 OCIMF 成员开展检查，由经 OCIMF 认证的船长和轮机长执行，覆盖油轮、驳船、散货船和海上装置。")
	return /** @type {LocalizedString} */ ("Inspections on behalf of OCIMF members, carried out by OCIMF-accredited Master Mariners and Chief Engineers across tankers, barges, bulk carriers and offshore units.")
});